import { SetStateAction, Dispatch, ReactElement } from 'react';
import { Button } from '@ff-it/ui';

interface TailToggleProps {
  count?: number;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
}

export function TailToggler({ count, show, setShow }: TailToggleProps): ReactElement {
  return (
    <Button
      variant="ghost"
      className="w-100 font-weight-normal"
      size="xs"
      onClick={() => setShow((s) => !s)}
      icon={`chevron-${show ? 'up' : 'down'}` as any}
    >
      {count && <strong>{count}</strong>} {show ? 'less' : 'more'}
    </Button>
  );
}
